import { motion } from "framer-motion"
import { CheckCircle, ArrowRight } from "lucide-react"

interface SuccessModalProps {
  isOpen: boolean
  onContinue: () => void
}

export const SuccessModal = ({ isOpen, onContinue }: SuccessModalProps) => {
  if (!isOpen) return null

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4"
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        transition={{ type: "spring", duration: 0.6 }}
        className="bg-white rounded-3xl shadow-2xl max-w-md w-full mx-4 overflow-hidden"
      >
        {/* Header */}
        <div className="bg-gradient-to-br from-green-500 to-green-600 px-6 py-8 text-center">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: "spring" }}
            className="w-16 h-16 mx-auto mb-4 bg-white/20 rounded-2xl flex items-center justify-center"
          >
            <CheckCircle className="w-8 h-8 text-white" />
          </motion.div>

          <h2 className="text-2xl font-bold text-white mb-2">Password Set Successfully!</h2>
          <p className="text-green-100 text-sm">Your account is now ready to use</p>
        </div>

        {/* Content */}
        <div className="p-6 text-center space-y-6">
          <div>
            <p className="text-gray-600 leading-relaxed">
              Great! Your password has been created successfully. You can now sign in to your account and start using
              our services.
            </p>
          </div>

          <motion.button
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            onClick={onContinue}
            className="w-full bg-gradient-to-r from-sky-500 to-sky-600 hover:from-sky-600 hover:to-sky-700 text-white font-semibold py-4 px-6 rounded-2xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98]"
          >
            <div className="flex items-center justify-center gap-2">
              <span>Continue to Sign In</span>
              <ArrowRight className="w-5 h-5" />
            </div>
          </motion.button>
        </div>
      </motion.div>
    </motion.div>
  )
}
